import { Col, Row, Tabs, Typography } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { BackButton } from 'src/components/BackButton/BackButton';
import { DetailsPage } from 'src/components/FormPages/DetailsPage';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { MerchantApplicationsTab } from 'src/pages/MerchantDetailsPage/tabs/MerchantApplicationsTab';
import { MerchantGeneralInfoTab } from 'src/pages/MerchantDetailsPage/tabs/MerchantGeneralInfoTab';
import { MerchantsStore } from 'src/stores/MerchantsStore/MerchantsStore';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';

export const MerchantDetailsPage = observer(() => {
    const merchant = MerchantsStore.currentItem;

    return (
        <DetailsPage
            pageName="partner-details"
            store={MerchantsStore as unknown as BasicStore<Entity>}
            headerTopPanel={<BackButton to={EntityLinks.merchants.list?.()} />}
        >
            <Row gutter={16}>
                <Col flex={1}>
                    <Typography.Title level={3}>
                        {t('App.Pages.MerchantDetails.Title', {
                            id: merchant?.number,
                            name: merchant?.name,
                        })}
                    </Typography.Title>
                </Col>
            </Row>

            <Tabs
                items={[
                    {
                        key: 'general-information',
                        label: t(
                            'App.Pages.PartnerDetails.Tab.GeneralInformation',
                        ),
                        children: (
                            <MerchantGeneralInfoTab merchant={merchant} />
                        ),
                    },
                    {
                        key: 'applications',
                        label: t('App.Pages.MerchantDetails.Tab.Applications'),
                        children: (
                            <MerchantApplicationsTab merchant={merchant} />
                        ),
                    },
                ]}
            />
        </DetailsPage>
    );
});
